// extracted by mini-css-extract-plugin
export default {"selectorContainer":"CardMoveStep_selectorContainer__WmMyj","text":"CardMoveStep_text__Ds3l-","selector":"CardMoveStep_selector__LjMW7"};